import * as React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import mainContext from "../../../context/mainContext";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import { IconButton } from "@mui/material";
import ScrollSubtitles from "./ScrollSubtitles";
import { useEffect } from "react";
import { Button } from "antd";
import CancelIcon from "@mui/icons-material/Cancel";

export default function SubtitleSidebar({
  seekToVideo,
  activeSubtitleOneId,
  activeSubtitleTwoId,
  handleSubtitleSideBar,
}) {
  const theme = useTheme();
  const [activeTab, setActiveTab] = React.useState(0);
  const { allSubtitleOne, allSubtitleTwo } = React.useContext(mainContext);

  const handleChangeTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  const showTab = (key) => {
    let tab;
    switch (key) {
      case 0:
        tab =
          allSubtitleOne.length > 0 ? (
            <ScrollSubtitles
              activeSubtitleId={activeSubtitleOneId}
              list={allSubtitleOne}
              seekToVideo={seekToVideo}
              subNum={"one"}
            />
          ) : (
            <Typography>زیرنویس فعال برای نمایش وجود ندارد</Typography>
          );
        break;
      case 1:
        tab =
          allSubtitleTwo.length > 0 ? (
            <ScrollSubtitles
              activeSubtitleId={activeSubtitleTwoId}
              list={allSubtitleTwo}
              seekToVideo={seekToVideo}
              subNum={"two"}
            />
          ) : (
            <Typography>زیرنویس فعال برای نمایش وجود ندارد</Typography>
          );
        break;
      case 2:
        tab = (
          <Box>
            <Typography>در حال بررسی جهت اجرا در نسخه های بعدی</Typography>
            <Typography sx={{ fontSize: "12px" }}>
              لطفا از طریق فرم ارسال پیشنهاد و درخواست در منوی پشتیبانی نظرات
              خود را با ما به اشتراک گذارید
            </Typography>
            <Typography sx={{ fontSize: "12px" }}>
              با توجه به تعداد درخواست ها امکانات مورد نیاز به برنامه اضافه
              خواهد شد
            </Typography>
          </Box>
        );
        break;
      case 3:
        tab = (
          <Box>
            <Typography>در حال بررسی جهت اجرا در نسخه های بعدی</Typography>
            <Typography>
              لطفا از طریق فرم ارسال پیشنهاد و درخواست در منوی پشتیبانی نظرات
              خود را با ما به اشتراک گذارید
            </Typography>
            <Typography>
              با توجه به تعداد درخواست ها امکانات مورد نیاز به برنامه اضافه
              خواهد شد
            </Typography>
          </Box>
        );
        break;
    }
    return tab;
  };
  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        width: "100%",
        height: "100%",
      }}
    >
      <Box sx={{ height: "15%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
            px: 1,
            alignItems: "center",
          }}
        >
          <IconButton
            sx={{ p: 0, m: 0 }}
            color="error"
            onClick={() => {
              handleSubtitleSideBar({ active: false });
            }}
          >
            <CancelIcon />
          </IconButton>
          <Typography>shortCut Key: Alt + C </Typography>
        </Box>
        <Typography>نمایش زیرنویس ها</Typography>
        <AppBar position="static">
          <Tabs
            value={activeTab}
            onChange={handleChangeTab}
            indicatorColor="secondary"
            variant="scrollable"
            scrollButtons="auto"
            textColor="inherit"
            aria-label="full width tabs example"
          >
            <Tab label="زیرنویس اول" />
            <Tab label="زیرنویس دوم" />
            <Tab label="لغات و اصطلاحات داخل فیلم" />
            <Tab label="لغات ذخیره شده" />
          </Tabs>
        </AppBar>
      </Box>

      <Box sx={{ width: "100%", height: "80%" }}>{showTab(activeTab)}</Box>
    </Box>
  );
}
